import React from 'react';

function FooterItemWrapper({ children }: React.PropsWithChildren<{}>) {
    return (
        <div className="footer-item m-1">
            {children}
        </div>
    );
}

export default FooterItemWrapper;
